import React, { useEffect, useState } from "react"
import { ModalPopUp } from "../../common/element/ModalPopUp"
import { IMG } from "../../common/CONST"
import { IModalMessage } from "../../../types/error/IModalMessage"
import { IClientContractorContract } from "../../../types/contractor/IClientContractorContract"
import { IErrorModel } from "../../../types/error/IErrorModel"
import { IBrockmanBankDto } from "../../../types/brockman/IBrockmanBankDto"
import * as TrinityAPI from "../../../requests/TrinityAPI"
import { download, getFormattedDate } from "../../common/CommonHelper"
import { useParams } from "react-router-dom"

export const ContractorClientContract: React.FC<{
  contracts: IClientContractorContract[]
  setContracts: (contracts: IClientContractorContract[]) => void
  errors: IErrorModel | undefined
}> = ({ contracts, setContracts, errors }) => {
  const [banks, setBanks] = useState<IBrockmanBankDto[]>([])
  const [modalMessage, setModalMessage] = useState<IModalMessage | null>(null)
  const [currentContractIndex, setCurrentContractIndex] = useState(0)
  const params = useParams()

  const deleteContract = (contractId: string | undefined) => {
    if (!params.id || !contractId) return
    TrinityAPI.deleteContractorTemplate(params.id, contractId, response => {
      if (response.status === 200) {
        window.location.reload()
      }
    })
  }

  useEffect(() => {
    TrinityAPI.getBrockmanBanks(response => {
      if (response.status === 200) {
        setBanks(response.data)
      }
    })
  }, [contracts])

  return (
    <>
      <ModalPopUp message={modalMessage} close={() => setModalMessage(null)} />
      <li className="form-block-popup">
        <h4 className="heading-chapter">Шаблоны</h4>
        <div className="flex-row-10 centred_row flex-wrap">
          {contracts.length > 0 ? (
            contracts.map((c, index) => (
              <button
                className={`btn ${index === currentContractIndex ? "black-btn" : "grey-btn"} btn-bank-account`}
                key={index}
                onClick={() => setCurrentContractIndex(index)}
              >
                {c.name}
                <img src={IMG.close_acc} alt="" className="close-account-img" onClick={() => deleteContract(c.id)} />
              </button>
            ))
          ) : (
            <p>Нет шаблонов</p>
          )}
        </div>
        {contracts.map((c, index) =>
          index === currentContractIndex ? (
            <React.Fragment key={index}>
              <div className="flex-row-10 centred_row">
                <fieldset>
                  <legend>Название</legend>
                  <p className="text-form">{c.name}</p>
                </fieldset>
              </div>
              <div className="flex-row-10 flex-wrap">
                <fieldset>
                  <legend>Дата</legend>
                  <p className="text-form">{getFormattedDate(c.date || "")}</p>
                </fieldset>
                <fieldset>
                  <legend>Номер контракта</legend>
                  <p className="text-form">{c.number}</p>
                </fieldset>
              </div>
              <div className="flex-row-justify">
                <button className="btn download-btn" onClick={() => download(c.id, "TEMPLATE_CONTRACT")}>
                  <img src={IMG.download} alt="" />
                  Скачать
                </button>
              </div>

              <legend>Доп. соглашения</legend>
              {c.agreements?.map((a, aIndex) => (
                <div style={{ padding: "15px" }} key={aIndex}>
                  <div className="file-heading contractor-client-aggrements">
                    <h5>
                      {banks.filter(b => b.id === a.bankId)[0]
                        ? banks.filter(b => b.id === a.bankId)[0].name
                        : "Загрузка..."}
                    </h5>
                    <p>{a.brockmanDetail?.name || "-"}</p>
                  </div>
                  <div className="flex-row-10 flex-wrap" style={{ paddingBottom: "15px" }}>
                    <fieldset>
                      <legend>Дата</legend>
                      <p className="text-form">{getFormattedDate(a.date || "")}</p>
                    </fieldset>
                    <fieldset>
                      <legend>Номер</legend>
                      <p className="text-form">{a.number}</p>
                    </fieldset>
                  </div>
                  <div className="flex-row-justify">
                    <button className="btn download-btn" onClick={() => download(a.id, "TEMPLATE_AGREEMENT")}>
                      <img src={IMG.download} alt="" />
                      Скачать
                    </button>
                  </div>
                </div>
              ))}
            </React.Fragment>
          ) : null
        )}
      </li>
    </>
  )
}
